// extracted by mini-css-extract-plugin
export default {"editLivetalkStep2":"FcXWHPeqaacxllysa9c3","buttons":"q8jX44JxUhsaOUQ0KuGj","providerUrl":"d7YA1ZoSegTwhAwkKlKf","actions":"VeAIajN7pGR98ByXQtWc"};